import React, { useState, useEffect, useMemo } from "react";
import { Accordion } from "react-bootstrap";
import "./OpalAccordionItem.css";
import { getAll } from "../../localDB";
import OpalCardFactory from "../OpalCardFactory/OpalCardFactory";
import { SyncStatusMap } from "../../visualizations/visualizations";

const OpalAccordionItem = ({ items, search, onSelectItem, type, selectedCard, setSelectedCard, groupby }) => {

    const [institutions, setInstitutions] = useState([]);

    useEffect(() => {
        const fetchInstitutions = async () => {
            try {
                const data = await getAll("institution");
                const filtered = data.filter(item => item.SyncStatus !== SyncStatusMap.done);
                setInstitutions(filtered);
            } catch (error) {
                console.error("Failed to fetch", error);
            }
        };

        fetchInstitutions();
    }, []);

    const institutionMap = useMemo(() => {
        const map = {};
        institutions.forEach(inst => {
            map[inst.ID] = inst.Name;
        });
        return map;
    }, [institutions]);

    const getInstitutionName = (id) => institutionMap[id];

    function getValueByKey(obj, key) {
        return obj?.[key];
    }

    const groupedItem = useMemo(() => {
        return items.reduce((acc, item) => {
            const customer = item.Customer;
            const groupValue = getValueByKey(customer, groupby) ?? 'Ungrouped';

            if (!acc[groupValue]) {
                acc[groupValue] = {
                    key: groupValue,
                    items: []
                };
            }

            acc[groupValue].items.push(item);
            return acc;
        }, {});
    }, [items, institutionMap, groupby]);



    useEffect(() => {
        const keys = Object.keys(groupedItem).map((_, index) => index.toString());
        setActiveKeys(keys);
    }, [items, institutionMap]);

    const [activeKeys, setActiveKeys] = useState(null);

    const handleAccordionClick = (eventKey) => {
        setActiveKeys((prevKeys) =>
            prevKeys.includes(eventKey)
                ? prevKeys.filter((key) => key !== eventKey) // Close if already open
                : [...prevKeys, eventKey] // Open if closed
        );
    };

    const toProperCase = (text) =>
        text?.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

    return (
        <div className="opal-accordion-item px-2 pt-2">
            {groupby && groupedItem ? (
                <Accordion activeKey={activeKeys} alwaysOpen>
                    {Object.entries(groupedItem).map(([key, data], index) => (
                        <Accordion.Item eventKey={index.toString()} key={key}>
                            <Accordion.Header className="p-0 mb-2" onClick={() => handleAccordionClick(index.toString())}>
                                <div className="d-flex flex-column py-1">
                                    <span className="acc-subheader mb-1">{toProperCase(data.key?.toString() ?? 'Ungrouped')}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body className="py-0 px-0">
                                {Array.isArray(data.items) &&
                                    data.items.map((item) =>
                                        OpalCardFactory(type, {
                                            item,
                                            selectedCard,
                                            setSelectedCard,
                                            search,
                                            onSelectItem
                                        })
                                    )}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            ) : (
                items.map((item) =>
                    OpalCardFactory(type, {
                        item,
                        selectedCard,
                        setSelectedCard,
                        search,
                        onSelectItem
                    })
                )
            )}
        </div>

    );
};

export default OpalAccordionItem;
